export const KEY_RANGE_LOCKING_REQUEST_TYPE = '.KeyRangeLockingRequestMsg.keyRangeLockingRequest';
export const KEY_RANGE_LOCKING_RESPONSE_TYPE = '.KeyRangeLockingResponseMsg.keyRangeLockingResponse';
